import {
  createGoldBotResourceReader,
  isPlainObject,
} from "./goldBotResource";

export const getGoldBotStrategies = createGoldBotResourceReader({
  path: "/strategies",
  label: "strategies",
  isValidPayload: (payload) =>
    isPlainObject(payload) &&
    Array.isArray(payload.strategies) &&
    typeof payload.stale === "boolean",
});
